import { render, staticRenderFns } from "./LeftPageNavigation.vue?vue&type=template&id=e871e970&"
import script from "./LeftPageNavigation.vue?vue&type=script&lang=js&"
export * from "./LeftPageNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports